import { renderDate, renderDateValue } from '../utility/personTabGridHelper';

export const PRIORITY_OPTIONS = ['1', '2', '3', '4', '5'].map((value) => ({
  value,
  label: value,
}));

export const BULLETIN_DEFAULT_VALUES = {
  AlertType: '',
  AgencyID: '',
  Priority: '1',
  Beginning: new Date(),
  Ending: null,
  RangeOfEffectiveness: '',
  ptsPersonID: null,
  ptsAddressID: null,
  ptsVehicleID: null,
  Plate: '',
  PlateState: '',
  OLN: '',
  OLNState: '',
  Notification: '',
};

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const AGENCY_SELECT_PROPS = {
  optionValue: 'AgencyID',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const PRIORITY_SELECT_PROPS = { optionValue: 'value', optionLabel: 'label' };

export const BULLETIN_GRID_COLUMNS = [
  { field: 'AlertType', headerName: 'Alert Type', width: 160 },
  { field: 'AgencyID', headerName: 'Agency', width: 150 },
  { field: 'Beginning', headerName: 'Beginning', width: 180, valueFormatter: renderDate },
  { field: 'Ending', headerName: 'Ending', width: 180, valueFormatter: renderDate },
  { field: 'Person', headerName: 'Person', width: 180 },
  { field: 'OLN', headerName: 'OLN', width: 150 },
  { field: 'OLNState', headerName: 'OLN State', width: 140 },
  { field: 'Plate', headerName: 'Plate', width: 150 },
  { field: 'PlateState', headerName: 'Plate State', width: 140 },
  { field: 'Address', headerName: 'Address', width: 220 },
  { field: 'Ranges', headerName: 'Ranges', width: 200 },
  { field: 'Notification', headerName: 'Notification', width: 220 },
  { field: 'Priority', headerName: 'Priority', width: 130 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];

export const BULLETIN_DETAIL_FIELDS = [
  { field: 'AlertType', label: 'Alert Type' },
  { field: 'AgencyID', label: 'Agency' },
  { field: 'Beginning', label: 'Beginning', render: renderDateValue },
  { field: 'Ending', label: 'Ending', render: renderDateValue },
  { field: 'Person', label: 'Person' },
  { field: 'OLN', label: 'OLN' },
  { field: 'OLNState', label: 'OLN State' },
  { field: 'Plate', label: 'Plate' },
  { field: 'PlateState', label: 'Plate State' },
  { field: 'Address', label: 'Address' },
  { field: 'Ranges', label: 'Ranges' },
  { field: 'Notification', label: 'Notification' },
  { field: 'Priority', label: 'Priority' },
];
